
export default function preventNav (formIsDirty: boolean) {
  if (formIsDirty) {
    window.onbeforeunload = () => formIsDirty
  } else {
    window.onbeforeunload = null
  }
}
